import { toast } from "react-toastify";
import {
  deleteDataFromApi,
  getDataFromApi,
  postDataFromApi,
  putDataFromApi,
} from "../../../../../services/commonServices";
import {
  itemsCreateApi,
  itemsDeleteApi,
  itemsGetApi,
  itemsnUpdateApi,
} from "../../../../../services/api";
import { decryptDataForURL } from "../../../../../utills/useCryptoUtils";
import { handleCalibrationCreateUpdate } from "../Calibration/CalibrationHandler";
import { handleAMCCreateUpdate } from "../AMC/AMCHandler";

export const handleGetPurchaseItem = async (
  item_id,
  setFormData,
  setIsOverlayLoaders,
  status = "",
  callback=null
) => {
  try {
    setIsOverlayLoaders(true);
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.split("?")[1]);
    const action = decryptDataForURL(params.get("status"));
    let res = await getDataFromApi(itemsGetApi + "?item_id=" + item_id);

    if (res.data.status === 200) {
      if (action === "View") {
        res.data.data.fk_category_id =
          res.data.data?.category_details?.category_name;
      }
      setFormData((prevFormData) => {
        return {
          0: {
            ...prevFormData[0],
            ...res?.data?.data,
            ...res?.data?.data?.item_insurance_json,
            ...res?.data?.data?.calibration_details,
            ...res?.data?.data?.amc_details,
            fk_company:
              res?.data?.data.item_services === "Calibration"
                ? status === "View"
                  ? res?.data?.data?.calibration_details?.company_details?.company_name
                  : res?.data?.data?.calibration_details?.fk_company
                : status === "View"
                  ? res?.data?.data?.amc_details?.cmp_name
                  : res?.data?.data?.amc_details?.cmp_id,
            fk_branch:
              res?.data?.data.item_services === "Calibration"
                ? status === "View"
                  ? res?.data?.data?.calibration_details?.branch_details?.branch_name
                  : res?.data?.data?.calibration_details?.fk_branch
                : status === "View"
                  ? res?.data?.data?.amc_details?.br_name
                  : res?.data?.data?.amc_details?.br_id,

            fk_department:
              status === "View"
                ? res?.data?.data?.amc_details?.dept_name
                : res?.data?.data?.amc_details?.dept_id,

            fk_itemmaster:
              status === "View"
                ? res?.data?.data?.amc_details?.item_rm_cod
                : res?.data?.data?.amc_details?.item_id,
          },
        };
      });
      if(callback){
        callback()
      }
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  } finally {
    setIsOverlayLoaders(false);
  }
};

export const handlePurchaseItemCreateUpdate = async (
  formData,
  handleSubmit,
  setIsOverlayLoader,
  navigate,
  formConfig,
) => {
  try {
    setIsOverlayLoader(true);
    let isValidate = handleSubmit();
    if (!isValidate) {
      return false;
    }
    let item_insurance_json = {};
    formConfig.sections[0].fields?.forEach((field) => {
      if (field.isInsuranceField && field.type != "label") {
        item_insurance_json = {
          ...item_insurance_json,
          [field.name]: formData[0]?.[field.name] || "",
        };
      }
    });
    let payloadData = formData[0];
    // payloadData.fk_item_calibration_id = formData[0]?.fk_calibration_id
    payloadData.item_insurance_json = item_insurance_json;
    payloadData.item_rm_code = payloadData.item_rm_code || "test";
    let res;
    if ([formData[0]?.item_services].includes("Calibration")) {
      await handleCalibrationCreateUpdate(
        formData,
        handleSubmit,
        setIsOverlayLoader,
        null,
        1,
        "",
        null,
        null,
        null,
        1,
        (calibID) => {
          if (calibID) {
            payloadData.fk_item_calibration_id = calibID;
          }
        },
      );
      if (!payloadData.fk_item_calibration_id) {
        return;
      }
    } else if ([formData[0]?.item_services].includes("AMC")) {
      await handleAMCCreateUpdate(
        formData,
        handleSubmit,
        setIsOverlayLoader,
        null,
        "Posted",
        "",
        null,
        null,
        null,
        1,
        (amcId) => {
          if (amcId) {
            payloadData.fk_item_amc_id = amcId;
          }
        },
      );
      if (!payloadData.fk_item_amc_id) {
        return;
      }
    }

    if (formData[0].item_id) {
      res = await postDataFromApi(
        itemsnUpdateApi + "?item_id=" + formData[0].item_id,
        payloadData,
      );
    } else {
      res = await postDataFromApi(itemsCreateApi, payloadData);
    }
    if (res?.data?.status === 200) {
      toast.success(res?.data?.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      navigate("/itemlist");
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  } finally {
    setIsOverlayLoader(false);
  }
};

export const handlePurchaseItemDelete = async (
  item_id,
  setIsDelete,
  getAllListingData,
  setPopupIndex,
) => {
  try {
    let res = await deleteDataFromApi(itemsDeleteApi + "?item_id=" + item_id);
    if (res?.data?.status === 200) {
      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      getAllListingData();
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  } finally {
    setIsDelete(false);
    setPopupIndex(-1);
  }
};
